module.exports = __webpack_public_path__ + "static/media/slot.js.070a68d1.map";